import { cn } from 'src/shared/utils/cn'

export const renderTextWithLinks = (text: string, showFullContent: boolean, onClick?: (url: string) => void) => {
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+\.[^\s]+)/g

  const parts = text.split(urlRegex)

  return parts.map((part, index) => {
    if (!part) return null

    if (urlRegex.test(part)) {
      const url = part.startsWith('www.') ? `https://${part}` : part
      return (
        <span
          className={cn('inline cursor-pointer text-[#0ba95e] hover:underline', !showFullContent && 'line-clamp-6')}
          key={index}
          onClick={() => onClick?.(url)}
        >
          {part}
        </span>
      )
    }

    return (
      <span className="inline" key={index}>
        {part}
      </span>
    )
  })
}
